import { OptionTableColumnsProps } from './types';
import OptionChainTableDesktop from './OptionChainTableDesktop';
import { useDeferredValue, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const OptionChainTable = ({ data }) => {
  const deferredData = useDeferredValue(data);
  const { t } = useTranslation('quote');

  const optionTableColumns: OptionTableColumnsProps[] = useMemo(
    () => [
      {
        dataIndex: 'lastPrice',
        key: 'lastPrice',
        title: t('Quote.OptionChain.last-price'),
      },
      {
        dataIndex: 'change',
        key: 'change',
        title: t('Quote.OptionChain.change'),
      },

      {
        dataIndex: 'bid',
        key: 'bid',
        title: t('Quote.OptionChain.bid'),
      },
      {
        dataIndex: 'ask',
        key: 'ask',
        title: t('Quote.OptionChain.ask'),
      },
      {
        dataIndex: 'volume',
        key: 'volume',
        title: t('Quote.OptionChain.volume'),
      },
      {
        dataIndex: 'openInterest',
        key: 'openInterest',
        title: t('Quote.OptionChain.open-interest'),
      },
    ],
    [t],
  );

  return (
    <div className="option-table">
      <OptionChainTableDesktop data={deferredData} optionTableColumns={optionTableColumns} />
    </div>
  );
};

export default OptionChainTable;
